"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var material_1 = require("@angular/material");
var cyber_trip_filter_service_1 = require("./cyber-trip.filter.service");
var CyberTripFiltersDialogComponent = /** @class */ (function () {
    function CyberTripFiltersDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.datePipe = new common_1.DatePipe('en-US');
        this.loading = false;
        this.errors = [];
        this.defaultDropdownConfig = {
            service: cyber_trip_filter_service_1.CyberTripFilterService,
            serviceFunction: 'listFilters',
            searchKey: 'filter_search'
        };
        this.driverDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Driver', loadingText: 'Loading Drivers...', noResultsText: 'No Drivers', serviceFunctionScope: 'drivers', getFilter: 'driver' });
        this.customerDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Customer', loadingText: 'Loading Customers...', noResultsText: 'No Customers', serviceFunctionScope: 'customers', getFilter: 'jobevent__customer_organization' });
        this.truckDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Truck', loadingText: 'Loading Trucks...', noResultsText: 'No Trucks', serviceFunctionScope: 'trucks', getFilter: 'truck' });
        this.carrierDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Carrier', loadingText: 'Loading Carriers...', noResultsText: 'No Carriers', serviceFunctionScope: 'carriers', getFilter: 'driver__carrier' });
        this.payableToDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Payable', loadingText: 'Loading Payables...', noResultsText: 'No Payables', serviceFunctionScope: 'payables', getFilter: 'jobevent__owner_organization' });
        this.projectDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Project', loadingText: 'Loading Projects...', noResultsText: 'No Projects', serviceFunctionScope: 'projects', getFilter: 'jobevent__job__project' });
        this.jobDropdownConfig = __assign({}, this.defaultDropdownConfig, { selectText: 'Select Job', loadingText: 'Loading Jobs...', noResultsText: 'No Jobs', serviceFunctionScope: 'jobs', getFilter: 'jobevent__job', query: {} });
        this.model = {
            startDate: null,
            endDate: null,
            job: null,
            project: null,
            customer: null,
            driver: null,
            truck: null,
            payableTo: null,
            carrier: null,
            edited: false,
            incomplete: false,
            retake: false,
            uninvoiced: false
        };
    }
    CyberTripFiltersDialogComponent.prototype.ngOnInit = function () {
        this.filterJobs();
    };
    CyberTripFiltersDialogComponent.prototype.onSelect = function (filterType, e) {
        this.model[filterType] = e;
    };
    CyberTripFiltersDialogComponent.prototype.submit = function () {
        this.convertDates();
        this.callback(this.model);
        this.dialogRef.close();
    };
    CyberTripFiltersDialogComponent.prototype.convertDates = function (assign) {
        if (assign === void 0) { assign = true; }
        var startDate, endDate;
        if (this.model.startDate) {
            startDate = new Date(this.model.startDate);
            var name_1 = this.datePipe.transform(startDate, 'MM/dd/yyyy');
            startDate.setHours(0, 0, 0, 0);
            if (assign) {
                Object.assign(this.model.startDate, { id: startDate.toISOString(), name: name_1 });
            }
        }
        if (this.model.endDate) {
            endDate = new Date(this.model.endDate);
            var name_2 = this.datePipe.transform(endDate, 'MM/dd/yyyy');
            endDate.setHours(23, 59, 59, 999);
            if (assign) {
                Object.assign(this.model.endDate, { id: endDate.toISOString(), name: name_2 });
            }
        }
        if (!assign) {
            return {
                startDate: startDate && startDate.toISOString(),
                endDate: endDate && endDate.toISOString()
            };
        }
    };
    CyberTripFiltersDialogComponent.prototype.onDateChanged = function (dates, type) {
        if (type === void 0) { type = ''; }
        this.model[type] = dates[0];
        this.filterJobs();
    };
    CyberTripFiltersDialogComponent.prototype.filterJobs = function () {
        var _a = this.convertDates(false), startDate = _a.startDate, endDate = _a.endDate;
        this.jobDropdownConfig.query = { jobevent__shift1_start__gte: startDate, jobevent__shift1_start__lte: endDate };
        this.jobDropdownConfig = __assign({}, this.jobDropdownConfig);
    };
    return CyberTripFiltersDialogComponent;
}());
exports.CyberTripFiltersDialogComponent = CyberTripFiltersDialogComponent;
